import { DashboardRoute } from '@ckmk/angular';
import { environment } from '@app/src/environments/environment';
import SolutionDashboardRoutes from '@app/src/app/modules/solution/routes/admin/solution.dashboard.routes';
import ServiceDashboardRoutes from '@app/src/app/modules/service/routes/admin/service.dashboard.routes';
import PostDashboardRoutes from '@app/src/app/modules/post/routes/admin/post.dashboard.routes';

export default DashboardRoute({
  hash: environment.ADMIN_HASH,
  components: {
    login: () =>
      import('@app/src/app/modules/admin/views/login/login.component').then(
        (m) => m.LoginComponent,
      ),
    dashboard: () =>
      import('@app/src/app/modules/admin/views/dashboard/dashboard.component').then(
        (m) => m.DashboardComponent,
      ),
  },
  routes: [SolutionDashboardRoutes, ServiceDashboardRoutes, PostDashboardRoutes],
});
